import React from "react";
import Lottie from "react-lottie";
import * as animationData from "../../assets/lottie/app-loading.json";

export const SetupLoadingAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-gray-50 p-6">
      <div className="flex justify-center mb-6">
        <Lottie options={defaultOptions} height={75} width={75} />
      </div>
      <h2 className="text-2xl font-bold mb-2">Setting up your account...</h2>
      <p className="text-gray-600 text-center mb-1">
        This usually takes just a moment.
      </p>
      <p className="text-gray-600 text-center">Thanks for your patience!</p>
    </div>
  );
};
